











































































































































































import Vue from 'vue';
import { required, minLength, requiredIf } from 'vuelidate/lib/validators';
import {
  LocationDisplayGroup,
  LocationEntity,
  ScanAuth,
  ScanAuthAPIReturn,
  GetAllEntitiesForCustomerOptions,
  GetCurrentScanningLocationOptions,
} from '../../../types';
import { apiPostRequest, logError } from '../helpers';

const apiBaseURL = process.env.VUE_APP_API_URL || '';

export default Vue.extend({
  name: 'login',
  data() {
    return {
      submitted: false,
      notAuthorized: false,
      loginForm: {
        location: null as any,
        securityScanningCode: null as any,
      },
    };
  },
  validations: {
    loginForm: {
      location: {
        required,
      },
      securityScanningCode: {
        required,
      },
    },
  },
  computed: {
    validLocationGroups(): LocationDisplayGroup[] | null {
      const groups: Array<{ name: string | null; locations: LocationEntity[] }> = this.validLocations.reduce(
        (accum: Array<{ name: string | null; locations: LocationEntity[] }>, location: LocationEntity) => {
          const existingEntry = accum.find((grouping) => grouping.name === location.groupName);

          if (existingEntry) {
            existingEntry.locations.push(location);
          } else {
            accum.push({
              name: location.groupName,
              locations: [location],
            });
          }

          return accum;
        },
        [],
      );

      if (groups.length === 1 && groups[0].name === null) {
        return null;
      } else {
        const existingOtherGroup = groups.find((group) => group.name && group.name.toLowerCase() === 'other');

        groups.forEach((group) => {
          if (group.name === null) {
            if (existingOtherGroup) {
              existingOtherGroup.locations = existingOtherGroup.locations.concat(group.locations);
            } else {
              group.name = 'Other';
            }
          }
        });

        return groups as LocationDisplayGroup[];
      }
    },
    validLocations(): LocationEntity[] {
      return (this as any).locations.filter((location: LocationEntity) => location.status === 1);
    },
  },
  async mounted() {
    (this as any).startLoading();

    if ((this as any).currentLocationSecurityScanningCode && (this as any).currentLocationId && (this as any).apiKey) {
      (this as any).stopLoading();

      this.$router.push({ name: 'scan' });

      return;
    }

    (this as any).updateQueryParameters();

    if ((this as any).securityScanningCode && (this as any).locationId) {
      this.loginForm.location = (this as any).locationId;
      this.loginForm.securityScanningCode = (this as any).securityScanningCode;

      (this as any).stopLoading();

      this.handleSubmit();

      return;
    }

    await (this as any).getAllLocations();

    await (this as any).setInitialValues();

    (this as any).stopLoading();
  },
  methods: {
    handleSubmit(): void {
      this.submitted = true;
      this.notAuthorized = false;

      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      (this as any).showLoader();

      this.authToLocation();
    },
    async authToLocation(): Promise<void> {
      try {
        const postBody: ScanAuth = {
          securityScanningCode: this.loginForm.securityScanningCode,
        };

        const apiReturn: ScanAuthAPIReturn = await apiPostRequest({
          apiKey: (this as any).apiKey || '',
          apiURL: `${apiBaseURL}customer/${(this as any).customerId}/location/${this.loginForm.location}/scanAuth`,
          postBody,
        });

        if (apiReturn.success && apiReturn.data) {
          const options: GetCurrentScanningLocationOptions = {
            apiKey: (this as any).apiKey,
            customerId: (this as any).customerId,
            locationId: this.loginForm.location,
            securityScanningCode: this.loginForm.securityScanningCode,
          };

          await this.$store.dispatch('appData/GET_CURRENT_SCANNING_LOCATION', options);

          (this as any).hideLoader();

          this.$router.push({
            name: 'scan',
          });
        } else {
          this.notAuthorized = true;

          this.loginForm.securityScanningCode = null;

          (this as any).hideLoader();
        }
      } catch (e) {
        console.log(e);

        logError(e);

        this.notAuthorized = true;

        this.loginForm.securityScanningCode = null;

        (this as any).hideLoader();
      }
    },
  },
});
